<template>
    <v-dialog
            :value="shownRelay"
            :persistent="true"
            width="400"
    >
        <v-card>
            <v-progress-linear
                    v-if="savingChanges"
                    color="primary"
                    indeterminate
            ></v-progress-linear>

            <v-card-title class="dlg-title-bar">
                Add New User
            </v-card-title>

            <v-card-text class="pt-3">

                <v-form ref="createSysAdminForm" @submit="$event.preventDefault()">
                    <v-text-field
                            dense
                            outlined
                            ref="username"
                            color="primary"
                            v-model="value.username"
                            label="Username"
                            placeholder="eg. person@domain.com"
                            :rules="[validationRules.required, validationRules.email]"
                            :loading="checkingUsername"
                            :readonly="usernameChecked"
                            @keydown.enter="duplicateUserName"
                    >
                    </v-text-field>

                    <template v-if="!duplicate && usernameChecked">
                        <v-text-field
                                dense
                                outlined
                                color="primary"
                                ref="fullName"
                                v-model="value.name"
                                label="Account Name"
                                :rules="[validationRules.required]"
                        >
                        </v-text-field>
                        <v-text-field
                                dense
                                outlined
                                ref="password"
                                color="primary"
                                v-model="value.password"
                                label="Password"
                                type="password"
                                placeholder="Password"
                                autocomplete="new-password"
                                :rules="[validationRules.required, validationRules.upperCase, validationRules.lowerCase, validationRules.numeric, validationRules.specialCharacter, validationRules.min6Characters]"
                        >
                        </v-text-field>
                        <v-switch
                                class="mt-0"
                                :loading="savingChanges"
                                color="primary"
                                v-model="value.disabled"
                                label="Disabled"
                                dense
                                hide-details
                        ></v-switch>
                    </template>

                    <template v-if="usernameChecked && duplicate">
                        <div class="d-flex justify-center mb-2">
                            <v-icon large color="amber">mdi-alert</v-icon>
                        </div>
                        <div class="overline text-center amber--text">
                            Username already exists
                        </div>
                        <div class="overline text-center amber--text">
                            Add user to site
                        </div>
                    </template>
                </v-form>

            </v-card-text>
            <v-divider/>

            <v-card-actions>
                <v-spacer/>

                <v-btn
                        class="ml-2"
                        small
                        color="primary"
                        @click="shownRelay = false"
                        outlined
                        size="small"
                        :disabled="savingChanges"
                >
                    Cancel
                </v-btn>

                <v-btn
                        @click="duplicateUserName"
                        small
                        class="ml-2"
                        color="secondary"
                        variant="contained"
                        size="small"
                        :disabled="checkingUsername"
                        :loading="checkingUsername"
                        v-if="!usernameChecked"
                >
                    Next
                </v-btn>

                <v-btn
                        @click="addUser"
                        small
                        class="ml-2"
                        color="secondary"
                        variant="contained"
                        size="small"
                        :disabled="savingChanges"
                        :loading="savingChanges"
                        v-if="usernameChecked && duplicate"
                >
                    Confirm Add User
                </v-btn>



                <v-btn
                        v-if="usernameChecked && !duplicate"
                        @click="createUser"
                        ref="addSysAdminBtn"
                        small
                        class="ml-2"
                        color="secondary"
                        variant="contained"
                        size="small"
                        :disabled="savingChanges"
                        :loading="savingChanges"
                >
                    Add New User
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {validationRules} from "@/core/codeFunctions";
import {format} from "date-fns"
import {mapGetters} from "vuex";
import {newReq} from "@/core/request";
import {User} from "@/models/user";

export default {
    emits: ['created'],
    props: {
        shown: {default: false, type: Boolean, required: true},
    },
    data() {
        return {
            val: null,
            con: console,
            format: format,
            value: new User({}),
            validationRules: validationRules,
            savingChanges: false,
            duplicate: false,
            checkingUsername: false,
            usernameChecked: false,
            confirmAddUser: false
        }
    },
    methods: {

        async addUser() {
            try {
                this.savingChanges = true
                const {_id} = await this.$newReq('POST', `users/addSite`, {username: this.value.username, site: this.$store.state.curSiteId})
                const addedUser = await this.users.once(_id)
                this.savingChanges = false;
                this.$emit('input', addedUser)
                this.shownRelay = false
            } catch (e) {
                console.log(e)
                this.savingChanges = false
            }
        },

        async createUser() {
            if (this.$refs.createSysAdminForm.validate()) {
                try {
                    this.savingChanges = true
                    this.value.siteIds.push(this.$store.state.curSiteId);
                    this.value.disabledSiteIds = [];
                    this.value.adminSiteId = this.$store.state.curSiteId;
                    const {_id} = await this.value.create()
                    const addedUser = await this.users.once(_id)
                    this.savingChanges = false;
                    this.$emit('input', addedUser)
                    this.shownRelay = false
                } catch (e) {
                    console.log(e)
                    this.savingChanges = false
                }
            }
        },
        async duplicateUserName() {
            try {
                if (this.validationRules.required(this.value.username) !== true || this.validationRules.email(this.value.username) !== true)
                    return this.$snack.error('Username/Email Validation Error')
                this.checkingUsername = true;
                const res = await this.$newReq('POST', 'users/checkUsername', {username: this.value.username})
                this.duplicate = res.duplicate
                this.usernameChecked = true;
                this.checkingUsername = false;
            } catch (e) {
                this.$snack.netWorkError();
                console.log(e);
                this.usernameChecked = false;
                this.checkingUsername = false;
            }
        },
    },
    watch: {
    },
    computed: {
        shownRelay: {
            get() {
                return this.shown
            },
            set(val) {
                this.$emit('update:shown', val);
            }
        },
        ...mapGetters(['users']),
    }
}
</script>

<style scoped>

</style>